import rollbar from '~/src/utilities/libs/rollbar';
import {userIsLoggedIn} from './account';
import {getBookmarks} from '~/src/utilities/feed/bookmark';
import {isEnabled} from '~/src/utilities/helpers/feature';
import {Feature} from '~/src/utilities/constants/feature';

let context = {
    bookmarks: [],
    likes: [],
    ratings: [],
    reactions: []
};
let onContextChange = () => {};

/**
 * Provide a way to migrate old bookmark storage formats
 */
const getLegacyBookmarks = () => {
    try {
        const storageValue = localStorage.getItem('bookmarks');
        if (storageValue !== null) {
            localStorage.removeItem('bookmarks');
            const oldBookmarks = JSON.parse(storageValue) || [];
            const newBookmarks = oldBookmarks.map((item) => {
                return {
                    id: item.id,
                    content: {id: item.metadata_id.toString()}
                };
            });
            localStorage.setItem('bookmarks_v1', JSON.stringify(newBookmarks));
            return newBookmarks;
        }
    } catch (error) {
        rollbar.info(`[context] Failed to get legacy bookmarks from local storage: ${error.message}`, error);
    }
    return null;
};

const deserializeContext = () => {
    try {
        return {
            bookmarks: JSON.parse(localStorage.getItem('bookmarks_v1')) || getLegacyBookmarks() || [],
            likes: JSON.parse(localStorage.getItem('likes')) || [],
            ratings: JSON.parse(localStorage.getItem('ratings')) || [],
            reactions: JSON.parse(localStorage.getItem('reactions')) || []
        };
    } catch (error) {
        rollbar.info(`[context] Failed to fetch context from local storage: ${error.message}`, error);
        return context;
    }
};

const serializeContext = (clearStorage = false) => {
    try {
        if (clearStorage) {
            localStorage.removeItem('bookmarks_v1');
        } else {
            localStorage.setItem('bookmarks_v1', JSON.stringify(context.bookmarks));
            localStorage.setItem('likes', JSON.stringify(context.likes.filter((like) => !like.transient)));
            localStorage.setItem('ratings', JSON.stringify(context.ratings));
            localStorage.setItem('reactions', JSON.stringify(context.reactions));
        }
    } catch (error) {
        rollbar.info(`[context] Failed to store context in local storage: ${error.message}`, error);
    }
};

const getData = () => context;

const setData = (data) => {
    context = {
        ...context
    };

    if (data) {
        Object.keys(data)
            .filter((key) => key in context)
            .forEach((key) => {
                switch (key) {
                    case 'bookmarks':
                        context[key] = data[key].map((item) => {
                            return {
                                id: item.id,
                                content: {id: item.content.id.toString()}
                            };
                        });
                        break;
                    default:
                        context[key] = data[key];
                        break;
                }
            });

        serializeContext();
        onContextChange(context);
    } else {
        context.bookmarks = [];
        context.likes = [];
        context.ratings = [];
        context.reactions = [];
        serializeContext(true);
        onContextChange(context);
    }
};

const startContext = async (data, callback = onContextChange) => {
    onContextChange = callback;

    if (process.browser) {
        const deserialized = deserializeContext();

        context = {
            bookmarks: deserialized.bookmarks,
            likes: deserialized.likes,
            ratings: deserialized.ratings.filter((rating) => !rating.transient),
            reactions: deserialized.reactions
                .filter((reaction) => !reaction.transient || reaction.deleted)
                .map((reaction) => {
                    const mapped = {...reaction};
                    delete mapped.deleted;

                    return mapped;
                })
        };

        if (userIsLoggedIn()) {
            try {
                if (isEnabled(Feature.BOOKMARKS)) {
                    await getBookmarks();
                }
            } catch (error) {
                rollbar.info(`[context] Error while fetching bookmarks: ${error.message}`, error);
            }
        }
    } else {
        context = {
            ...data
        };
    }

    onContextChange(context);
};

export {getData, setData, startContext};
